// Effetto magnetico: un solo listener mousemove globale per tutti gli elementi
// con attributo [data-magnetic]. Spostamento massimo 9px orizzontali / 7px
// verticali, raggio di attrazione 190px dal centro dell'elemento.
const RADIUS = 190;
const MAX_X = 9;
const MAX_Y = 7;
let started = false;
let raf = 0;
let pointer = null;
const nodes = new Set();
let mutation = null;

const canHover = () =>
  window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const clamp = (v, max) => Math.max(-max, Math.min(max, v));

const paint = () => {
  raf = 0;
  nodes.forEach((el) => {
    if (!pointer) {
      el.style.transform = '';
      return;
    }
    const r = el.getBoundingClientRect();
    if (!r.width) return;
    const maxX = Number(el.dataset.magneticX) || MAX_X;
    const maxY = Number(el.dataset.magneticY) || MAX_Y;
    const dx = pointer.x - (r.left + r.width / 2);
    const dy = pointer.y - (r.top + r.height / 2);
    if (Math.hypot(dx, dy) > RADIUS) {
      el.style.transform = 'translate(0px, 0px)';
      return;
    }
    el.style.transform = `translate(${clamp((dx / RADIUS) * maxX, maxX).toFixed(2)}px, ${clamp((dy / RADIUS) * maxY, maxY).toFixed(2)}px)`;
  });
};

const schedule = () => {
  if (!raf) raf = requestAnimationFrame(paint);
};

const onMove = (e) => {
  pointer = { x: e.clientX, y: e.clientY };
  schedule();
};

const onLeave = () => {
  pointer = null;
  schedule();
};

const sync = () => {
  const found = new Set(document.querySelectorAll('[data-magnetic]'));
  nodes.forEach((el) => {
    if (!found.has(el)) nodes.delete(el);
  });
  found.forEach((el) => nodes.add(el));
};

export const startMagnetic = () => {
  if (started || typeof window === 'undefined' || !canHover()) return () => {};
  started = true;

  sync();
  mutation = new MutationObserver(sync);
  mutation.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('mousemove', onMove, { passive: true });
  document.addEventListener('mouseleave', onLeave);
  window.addEventListener('blur', onLeave);

  return () => {
    window.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseleave', onLeave);
    window.removeEventListener('blur', onLeave);
    if (raf) cancelAnimationFrame(raf);
    if (mutation) mutation.disconnect();
    nodes.forEach((el) => { el.style.transform = ''; });
    nodes.clear();
    mutation = null;
    raf = 0;
    started = false;
  };
};

export default startMagnetic;
